import { FakDokument } from "../fak-dokument";

export class FakDokumentIzvoz extends FakDokument
{
    constructor(){
        super();
    }
    
    InstrukcijaZaPlacanje: string = "";
    ValutaID: number = null;
    Kurs: number = null;

    Deserialize(input: any){
        super.Deserialize(input);
        // this.ID = input.ID;
        this.InstrukcijaZaPlacanje = input.InstrukcijaZaPlacanje != null ? input.InstrukcijaZaPlacanje.trim() : input.InstrukcijaZaPlacanje;
        this.ValutaID = input.ValutaID;
        this.Kurs = input.Kurs;
        return this;
    }

    Serialize(input: FakDokumentIzvoz){
        return input;
    }
}